declare interface Array<T> {
  sortBalanceTree(displayOrderFieldName?: string, accountNumberFieldName?: string, mnemonicFieldName?: string): Array<T>;
}

Array.prototype.sortBalanceTree = function (
  displayOrderFieldName = 'DisplayOrder',
  accountNumberFieldName = 'AccountNumber',
  mnemonicFieldName = 'Mnemonic'
) {
  return this.sort((a, b) => {
    // Fix 1477: If the displayOrder is 0, it will be
    // interpreted for the displayOrder as it is a big number
    let displayOrderPair = [a[displayOrderFieldName], b[displayOrderFieldName]];
    displayOrderPair = displayOrderPair.map(element => {
      const elementNumber = +(<number>element);
      return /*elementNumber === 0 ? 999999 :*/ elementNumber; // Commented code is the anulation of the Fix 1477
    });
    if (displayOrderPair[0] === displayOrderPair[1]) {
      // Bug Fix 3153: It will order by account number if Display Order are the same, then by name if account number is the same
      if (a[accountNumberFieldName] === b[accountNumberFieldName]) {
        return a[mnemonicFieldName].toLowerCase() < b[mnemonicFieldName].toLowerCase() ? -1 : 1;
      } else {
        return a[accountNumberFieldName] - b[accountNumberFieldName];
      }
    } else {
      return displayOrderPair[0] - displayOrderPair[1];
    }
  });
};
